export function hasValidCorners(corners) {
  if (!corners) return false;

  const points = [corners.topLeft, corners.topRight, corners.bottomLeft];
  return points.every(
    (point) =>
      point &&
      Number.isFinite(Number(point.lat)) &&
      Number.isFinite(Number(point.lng)),
  );
}

export function normalizeCorners(corners) {
  if (!corners) return null;

  const normalizePoint = (point) => {
    if (!point) return null;
    const lat = Number(point.lat);
    const lng = Number(point.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return { lat, lng };
  };

  const topLeft = normalizePoint(corners.topLeft);
  const topRight = normalizePoint(corners.topRight);
  const bottomLeft = normalizePoint(corners.bottomLeft);

  if (!topLeft || !topRight || !bottomLeft) return null;
  return { topLeft, topRight, bottomLeft };
}
